var _rect, _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgErrorRed = function SvgErrorRed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, ">\n\n    ", _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    fill: "#ff0000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "M14.4 8c0-3.536-2.864-6.4-6.4-6.4A6.398 6.398 0 0 0 1.6 8c0 3.536 2.864 6.4 6.4 6.4 3.536 0 6.4-2.864 6.4-6.4zM16 8c0 4.416-3.584 8-8.008 8C3.576 16 0 12.416 0 8s3.576-8 7.992-8C12.416 0 16 3.584 16 8zM7.2 4h1.6v4.8H7.2zm0 6.4h1.6V12H7.2z",
    id: "svg_4",
    fillOpacity: 1
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error_red.bbf9548d.svg";
export { ForwardRef as ReactComponent };